import {
  useIsCopilotAdoptionCommunityAdminFREEnabled,
  useIsM365CopilotAdoptionEnabled,
} from '@ms/yammer-hooks/dist/groups';
import type { RenderCallback } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import React, { useCallback } from 'react';

import LoadableGroupCreateModal from '../LoadableGroupCreateModal';

type UseGroupCreateModal = (
  isCopilotAdoptionModal?: boolean,
  isCopilotAdoptionCommunityAdminFREEnabled?: boolean
) => ReturnType<typeof useRenderToggleableContent>;
export const useGroupCreateModal: UseGroupCreateModal = (
  isCopilotAdoptionModal = false,
  isCopilotAdoptionCommunityAdminFREEnabled = false
) => {
  const renderCallback: RenderCallback = useCallback(
    ({ hideContent }) => (
      <LoadableGroupCreateModal
        onDismiss={hideContent}
        isCopilotAdoptionModal={isCopilotAdoptionModal}
        isCopilotAdoptionCommunityAdminFREEnabled={isCopilotAdoptionCommunityAdminFREEnabled}
      />
    ),
    [isCopilotAdoptionModal, isCopilotAdoptionCommunityAdminFREEnabled]
  );

  return useRenderToggleableContent(renderCallback);
};

type UseCopilotAdoptionGroupCreateModal = () => ReturnType<typeof useRenderToggleableContent>;
export const useCopilotAdoptionGroupCreateModal: UseCopilotAdoptionGroupCreateModal = () => {
  const isCopilotAdoptionCommunityAdminFREEnabled = useIsCopilotAdoptionCommunityAdminFREEnabled();

  return useGroupCreateModal(true, isCopilotAdoptionCommunityAdminFREEnabled);
};

type UseCopilotAdminFREModal = () => ReturnType<typeof useRenderToggleableContent>;
export const useCopilotAdminFREModal: UseCopilotAdminFREModal = () => {
  const isM365CopilotAdoptionEnabled = useIsM365CopilotAdoptionEnabled();

  return useGroupCreateModal(isM365CopilotAdoptionEnabled, true);
};

export default useGroupCreateModal;
